module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/rewards/rumble-cd28331c5b37ccdde6c8b083f757407e.svg";